import { render, staticRenderFns } from "./mySurveyPage.vue?vue&type=template&id=8f71fb9a&scoped=true&"
import script from "./mySurveyPage.vue?vue&type=script&lang=ts&"
export * from "./mySurveyPage.vue?vue&type=script&lang=ts&"
import style0 from "./mySurveyPage.vue?vue&type=style&index=0&id=8f71fb9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f71fb9a",
  null
  
)

export default component.exports